import Button, { ButtonProps } from "shared/Button/Button";
import React from "react";

export interface ButtonPrimaryProps extends ButtonProps {
}

const ButtonPrimary: React.FC<ButtonPrimaryProps> = ({
  className = "",
  ...args
}) => {
  return (
    <Button
      className={`ttnc-ButtonPrimary disabled:bg-opacity-90 bg-violet-900 dark:bg-violet-100 hover:bg-violet-800 text-violet-50 dark:text-violet-800 shadow-xl ${className}`}
      {...args}
    />
  );
};

export default ButtonPrimary;
